import DebugService from './DebugService';
export var OfficeMode;
(function (OfficeMode) {
    OfficeMode["COMPOSE"] = "compose";
    OfficeMode["READ"] = "read";
    OfficeMode["UNKNOWN"] = "unknown";
})(OfficeMode || (OfficeMode = {}));
class OfficeModeService {
    constructor() { }
    static getInstance() {
        if (!OfficeModeService.instance) {
            OfficeModeService.instance = new OfficeModeService();
        }
        return OfficeModeService.instance;
    }
    /**
     * Get the current Office.js mode
     * @returns OfficeMode - COMPOSE, READ, or UNKNOWN
     */
    getCurrentMode() {
        try {
            const item = Office.context.mailbox.item;
            // Check if we're in compose mode by looking for saveAsync method
            if (item.itemType === Office.MailboxEnums.ItemType.Message && item.saveAsync) {
                DebugService.debug('Office mode detected: COMPOSE');
                return OfficeMode.COMPOSE;
            }
            // Check if we're in read mode
            if (item.itemType === Office.MailboxEnums.ItemType.Message && !item.saveAsync) {
                DebugService.debug('Office mode detected: READ');
                return OfficeMode.READ;
            }
            DebugService.debug('Office mode detected: UNKNOWN');
            return OfficeMode.UNKNOWN;
        }
        catch (error) {
            DebugService.error('Failed to detect Office mode');
            return OfficeMode.UNKNOWN;
        }
    }
    /**
     * Check if we're currently in compose (draft) mode
     * @returns boolean - true if in compose mode
     */
    isComposeMode() {
        return this.getCurrentMode() === OfficeMode.COMPOSE;
    }
}
export default OfficeModeService.getInstance();
